
import EmptyLayout from '@/views/layouts/empty-layout.vue'
import { CustomRouteRecordRaw } from 'vue-router'

export const packageRoutes: CustomRouteRecordRaw = {
  path: 'package',
  name: 'package',
  component: EmptyLayout,
  meta: {
    title: '套餐管理',
    iconfont: 'icon-folder-5-line',
    requiredPermission: 'package',
  },
  children: [
    {
      path: 'back-package',
      name: 'backPackage',
      component: () => import('@/views/package/back-package.vue'),
      meta: {
        title: '客户背调套餐',
        requiredPermission: 'package.back.list'
      },
    },
    {
      path: 'default-back-package',
      name: 'defaultBackPackage',
      component: () => import('@/views/package/default-back-package.vue'),
      meta: {
        title: '默认套餐列表',
        requiredPermission: 'package.back.default'
      },
    }
  ],
}